import * as React from "react";
import {useEffect, useMemo, useState} from "react";

const MapContext = React.createContext({
    map: null,
    isInitialized: false,
    init: () => {
    },
});

export function MapProvider({children}) {
    const [map, setMap] = useState({map: null, isInitialized: false});

    const initMap = (updatedMap) => {
        setMap((prev) => ({...prev, map: updatedMap}));
    };

    useEffect(() => {
        if (map.map && !map.isInitialized) {
            setMap((prev) => ({...prev, isInitialized: true}));
        } else if (!map.map && map.isInitialized) {
            setMap((prev) => ({...prev, isInitialized: false}));
        }
    }, [map.map, map.isInitialized]);

    const value = useMemo(
        () => ({...map, init: initMap}),
        [map.map, map.isInitialized]
    );

    return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
}

export function useMap() {
    return React.useContext(MapContext);
}
